/* eslint-disable angular/controller-as */

angular.module("dx.webapp.node").controller("DxNodeViewRouteController", function NodeViewRouteController(
	$cookies,
	$scope,
	$rootScope,
	$location,
	$routeParams,
	$anchorScroll,
	$timeout,

	NodeRepository,
	Node,
	dxApi,
	UIStateManager,
	dxSession,
	RoleTypeEnum,
	dxAngularConstantHelper,
	dxBitFlagsHelper,
	DX_REMOTE_PROCTOR_SETTING,

	dxLocalize,
	dxDialog,

	FileUploader,
	Raven
) {
	"use strict";

	$scope.dxSession = dxSession;
	$scope.RoleTypeEnum = RoleTypeEnum;
	$scope.DX_ARTICLE_TYPE = dxAngularConstantHelper.DX_ARTICLE_TYPE;

	$scope.reqs = {
		node: false,
	};

	var nodeId = $routeParams.id ? parseInt($routeParams.id, 10) : 0;
	$scope.nodeId = nodeId;

	$scope.mainState = new UIStateManager("default");
	var unsavedChanges = false;

	if (nodeId === 0) {
		$rootScope.$broadcast("notification:error", dxLocalize.get("The node you tried to visit doesn't exist."));
		$location.path("/");
		return;
	}

	$scope.tabs = ["users", "edit", "integrations", "external-tools", "client", "remote-proctoring"];
	if (dxSession.getRole().roleType === RoleTypeEnum.MASTER) {
		$scope.activeTab = $scope.tabs[0];
	} else {
		$scope.activeTab = $scope.tabs[1];
	}
	$scope.roleTypes = [2, 4, 16];

	// UI Helpers

	$scope.isActiveTab = function isActiveTab(tab) {
		return $scope.activeTab === tab;
	};

	$scope.unsavedChangesDetected = function unsavedChangesDetected(changes) {
		unsavedChanges = changes;
	};

	$scope.$on("$locationChangeStart", function saveBeforeLeave(event) {
		if (unsavedChanges) {
			var nextUrl = $location.url();
			event.preventDefault();

			dxDialog.confirm({
				actionIsDangerous: true,
				title: dxLocalize.get("LeaveWarning.Title"),
				body: dxLocalize.get("LeaveWarning.Body"),
				acceptText: dxLocalize.get("Ok"),
				acceptCallback: function accept() {
					dxDialog.closeMostRecent();
					unsavedChanges = false;
					$location.url(nextUrl);
				},
				rejectText: dxLocalize.get("Cancel"),
				rejectCallback: function reject() {
					dxDialog.closeMostRecent();
				},
			});
		}
	});

	$scope.setTab = function setTab(tab) {
		if ($scope.tabs.indexOf(tab) < 0) {
			return;
		}

		if (unsavedChanges) {
			dxDialog.confirm({
				actionIsDangerous: true,
				title: dxLocalize.get("LeaveWarning.Title"),
				body: dxLocalize.get("LeaveWarning.Body"),
				acceptText: dxLocalize.get("Yes"),
				acceptCallback: function accept() {
					dxDialog.closeMostRecent();
					switchTab();
				},
				rejectText: dxLocalize.get("No"),
				rejectCallback: function reject() {
					dxDialog.closeMostRecent();
				},
			});
		} else {
			switchTab();
		}

		function switchTab() {
			$scope.$broadcast("node:tabchanged");

			$scope.activeTab = tab;
			if (tab === $scope.tabs[0]) {
				$location.hash("");
			} else {
				$location.hash(tab);
				$anchorScroll();
			}

			unsavedChanges = false;
		}
	};

	// Initialization

	function setTabFromHash() {
		var hash = $location.hash();
		if (!hash) {
			if (dxSession.getRole().roleType === RoleTypeEnum.MASTER) {
				$scope.setTab("users");
			} else {
				$scope.setTab("edit");
			}
		} else if ($scope.tabs.indexOf(hash) >= 0) {
			$scope.setTab(hash);
		}
	}

	setTabFromHash();

	NodeRepository.load(nodeId).then(function onNodeLoad(node) {
		$scope.reqs.node = true;
		$scope.node = new Node(node);

		$scope.remoteProctoringEnabled = dxBitFlagsHelper.isBitIncluded($scope.node.remoteProctoringSetting, DX_REMOTE_PROCTOR_SETTING.ProctoringEnabled);
	});

	$scope.$on("$routeUpdate", setTabFromHash);

	// Upload cover and profile image section
	var requestHeaders = {};
	requestHeaders["X-CSRF-Token"] = $cookies.get("csrf");

	$scope.openProfileImageFileInput = function openProfileImageFileInput() {
		// Wrap it in a timeout to avoid angular throwing "$apply already in progress" error on Edge
		$timeout(function click() {
			angular.element("#node-edit-profileImage").click();
		});
	};

	$scope.openCoverImageFileInput = function openCoverImageFileInput() {
		// Wrap it in a timeout to avoid angular throwing "$apply already in progress" error on Edge
		$timeout(function click() {
			angular.element("#node-edit-coverImage").click();
		});
	};

	$scope.uploader = new FileUploader({
		alias: "file",
		headers: requestHeaders,
	});

	$scope.coverImageOptions = {
		imageType: "cover",
	};

	$scope.profileImageOptions = {
		imageType: "profile",
	};

	$scope.uploader.onAfterAddingFile = function onAfterAddingFile(file) {
		$scope.mainState.set("loading");

		file.url = dxApi.v1.files.uploadUrl();

		file.onSuccess = function onSuccess(response) {
			$scope.mainState.set("default");

			if (file.imageType === "cover") {
				$scope.node.coverImageUrl = response.link;
			} else if (file.imageType === "profile") {
				$scope.node.profileImageUrl = response.link;
			}
			// TODO: find a way to update the profile image in the dxNodeCreateEditController (node-create-edit-controller.js)
			// As it currently stands, the url isn't updated in the proper controller, which leads to reverting changes when saving.
			$scope.node.save();
			// eslint-disable-next-line angular/window-service,no-undef
			window.location.reload();
		};

		file.onError = function onError(response, status, headers) {
			$rootScope.$broadcast("notification:error", dxLocalize.get("UploadImage.FailedX", dxLocalize.get(response.msgs[0])));

			Raven.captureMessage("Node image upload failed", {
				extra: {
					url: file.url,
					response: response,
					status: status,
					headers: headers,
				},
			});
		};

		return file.upload();
	};
});
